var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.filters.length || _vm.moreFilters.length
    ? _c("section", { staticClass: "edge-container" }, [
        _c("div", { class: _vm.accordionWrapperClass }, [
          _c(
            "div",
            { class: ["product-finder", "background", _vm.background] },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _vm.useAccordion
                    ? _c(
                        "sal-accordion",
                        { attrs: { "init-open": true } },
                        [
                          _c("template", { slot: "header" }, [
                            _c("h3", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.localization.accordionHeader
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "body" },
                            [
                              _vm.filters.length
                                ? [
                                    _c("sal-filter-group", {
                                      attrs: { filters: _vm.filters },
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.moreFilters.length
                                ? [
                                    _c("p", {
                                      staticClass: "group__label",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.localization.labels.moreFilters
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.groupedMoreFilters,
                                      function (filterGroup) {
                                        return _c("sal-filter-group", {
                                          key: filterGroup[0],
                                          attrs: { filters: filterGroup[1] },
                                        })
                                      }
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "product-finder__filterarea" },
                        [
                          _vm.filters.length
                            ? [
                                _c("sal-filter-group", {
                                  attrs: { filters: _vm.filters },
                                }),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.moreFilters.length
                            ? [
                                _c("p", {
                                  staticClass: "group__label",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.localization.labels.moreFilters
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.groupedMoreFilters,
                                  function (filterGroup) {
                                    return _c("sal-filter-group", {
                                      key: filterGroup[0],
                                      attrs: { filters: filterGroup[1] },
                                    })
                                  }
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [_c("sal-filter-selected")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [_c("sal-results", { staticClass: "row" })],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }